// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__ffOdX","container":"Footer_container__GHthH","name":"Footer_name__1Dhft","address":"Footer_address__L1saA"};